<div class="qr-code-box">
  <div class="qr-code-box-container" (click)="openQrModel()">
    <div class="pin-char-container">
      <div class="pin-char">
        {{ editionPrefix }}
      </div>
      <span class="pin-char-hyphen"> - </span>
      @for (char of pinCode?.split(''); track $index) {
      <div class="pin-char">
        {{ char }}
      </div>
      }
    </div>
    <div class="qr" [innerHTML]="qrSvg"></div>
  </div>
</div>
